import { graphql } from 'react-apollo'
import { groupBy, keys } from 'ramda'
import { Layout, Table } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import productsStockQuery from '../graphql/queries/productsStock'

import '../css/table.css'

const { Content } = Layout

class Products extends Component {
  async componentDidMount() {
    console.log(this.props)
    const { group } = this.props.match.params
    await this.props.products.refetch({ group })
  }
  render() {
    console.log('render', this.props)
    const { products: { loading, products = [] } } = this.props
    const filterName = keys(groupBy(product => product.name, products)).map(product => ({ text: product, value: product }))
    const filterSize = keys(groupBy(product => product.size, products)).map(product => ({ text: product, value: product }))
    const filterColor = keys(groupBy(product => product.color, products)).map(product => ({ text: product, value: product }))
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        filters: filterName,
        onFilter: (value, record) => record.name === value,
      },
      {
        title: 'Size',
        key: 'size',
        filters: filterSize,
        onFilter: (value, record) => record.size === value,
        render: record => record.size || '-',
      },
      {
        title: 'Color',
        key: 'color',
        filters: filterColor,
        onFilter: (value, record) => record.color === value,
        render: record => record.color || '-',
      },
      {
        title: 'ID',
        key: 'id',
        width: 280,
        render: record => (<span>Shop: {record.sku || '-'}<br />Race: {record.shirtId || '-'}</span>),
      },
      {
        title: 'Check In',
        dataIndex: 'checkInItemCount',
        key: 'checkInItemCount',
        className: 'text-right',
      },
      {
        title: 'Stock',
        children: [
          {
            title: 'Race',
            dataIndex: 'stock.race',
            key: 'stock.race',
            className: 'text-right',
          },
          {
            title: 'Shop',
            dataIndex: 'stock.shop',
            key: 'stock.shop',
            className: 'text-right',
          },
          // {
          //   title: 'Inbox',
          //   dataIndex: 'stock.inbox',
          //   key: 'stock.inbox',
          //   className: 'text-right',
          // },
          {
            title: 'Total',
            dataIndex: 'stock.total',
            key: 'stock.total',
            className: 'text-right',
          },
        ],
      },
    ]
    return (
      <Layout>
        <Navbar selected="product:1" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>Products</h2>
            <Table
              dataSource={products}
              columns={columns}
              rowKey="_id"
              pagination={{ pageSize: 50 }}
              size="middle"
              loading={loading}
              bordered
            />
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Products.propTypes = {
  products: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    products: PropTypes.array,
    refetch: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
}
Products.defaultProps = {}

export default graphql(productsStockQuery, { name: 'products', options: { variables: { group: '' } } })(Products)



// WEBPACK FOOTER //
// ./src/pages/Products.js